{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "user": "User",
    "total_earned": "Total Earned",
    "current_balance": "Current Balance",
    "affiliate_link": "Affiliate Link",
    "share_link": "Share your link to invite and earn.",
    "copy": "Copy",
    "total_commissions": "Total Commissions",
    "career_plan": "Career Plan",
    "current_level": "You are currently at level",
    "next_level": "Advance to level",
    "next_level_short": "Next level",
    "current_bonus": "Current bonus",
    "next_bonus": "Next bonus",
    "residual_note": "You receive 1% recurring on your direct referrals’ PLR up to the 5th generation.",
    "my_quotas": "My Quotas",
    "view_all": "View all",
    "value": "Value",
    "created_at": "Created at",
    "finished_at": "Ends at",
    "status": "Status",
    "status_finished": "Finished",
    "status_in_progress": "In progress",
    "copied_success": "Link copied successfully",
    "load_error": "Error loading dashboard"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo",
    "nova_stake": "New Stake",
    "sacar": "Withdraw",
    "trazer_corretora": "Pull from Broker",
    "saldo": "Balance",
    "sair": "Logout",
    "deposit": "Deposit",
    "historico": "History"
  },
  "sidebar": {
    "dashboard": "Home",
    "stake": "Stake",
    "content_education": "Educational content",
    "history": "History",
    "earnings": "Earnings",
    "network": "Network",
    "my_quotas": "My Quotas",
    "create_new": "Create new quota",
    "empty_title": "You don't have any quotas yet",
    "empty_subtitle": "Create your first quota to get started.",
    "create_first": "Create my first quota",
    "copytrade": "Copytrade",
    "support": "Support",
    "operations": "Operations",
    "primezord": "Primezord",
    "saldo_disponivel": "Available Balance",
    "voltar_corretora": "Back to Broker",
    "tempo_sessao": "Session Time Remaining"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  },
  "stakes": {
    "start_date": "Start Date",
    "create_in": "Start Date",
    "duration": "Duration",
    "status": "Status",
    "status_active": "In progress",
    "status_Finalizada": "Finished",
    "amount": "Stake Amount",
    "profit": "Profit Generated",
    "progress": "Progress",
    "cancel_button": "Cancel Stake",
    "modal_title": "Cancel Stake",
    "modal_description": "Are you sure you want to cancel the stake worth",
    "modal_close": "Close",
    "created_in": "Criada Em",
    "modal_confirm": "Confirm Cancellation"
  },
  "history": {
    "copytrade": "CopyTrade",
    "stakes": "Stakes",
    "operacoes": "Operations",
    "saques": "Withdrawals",
    "bonus": "Bonus",
    "residual": "Residual",
    "primezord": "Primezord",
    "start_date": "Start Date",
    "end_date": "End Date",
    "status": {
      "canceled": "Canceled",
      "complete": "Complete",
      "in_progress": "In Progress",
      "finished": "Finished"
    },
    "columns": {
      "date": "Date",
      "value": "Value",
      "status": "Status",
      "invested": "Invested Amount",
      "profit": "Profit Generated",
      "pair": "Pair",
      "payout": "Payout",
      "description": "Description",
      "source": "Source",
      "reference": "Reference",
      "total": "Total",
      "percentage": "Percentage",
      "notes": "Notes"
    }
  },
  "network": {
    "email": "Email",
    "phone": "Phone",
    "balance": "Balance",
    "loading": "Loading network..."
  },
  "copytrade": {
    "title": "Active CopyTrades",
    "create": "Create New CopyTrade",
    "empty": "No CopyTrades currently active.",
    "start_date": "Start Date",
    "status": "Status",
    "status_active": "In progress",
    "status_expired": "Expired",
    "invested": "Invested Capital",
    "profit": "Profit Generated",
    "modal_title": "Create New CopyTrade",
    "modal_description": "Select the amount you wish to invest.",
    "investment_amount": "Investment Amount",
    "select": "Select...",
    "start_copy": "Start CopyTrade",
    "cancel": "Cancel",
    "alert_select_amount": "Please select an amount"
  },
  "operations": {
    "start_date": "Start Date",
    "end_date": "End Date",
    "asset": "Asset",
    "all": "All",
    "loading": "Loading operations...",
    "columns": {
      "date": "Date",
      "asset": "Asset",
      "payout": "Payout"
    }
  },
  "profile": {
    "title": "Update Profile",
    "avatarTitle": "Profile Picture",
    "selectImage": "Select an image.",
    "saveAvatar": "Save Avatar",
    "personalInfo": "Personal Information",
    "phone": "Phone",
    "birth": "Birthdate",
    "saveData": "Save Data",
    "changePassword": "Change Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm Password",
    "savePassword": "Save Password",
    "updatedSuccess": "Successfully updated.",
    "updatedError": "Error updating.",
    "passwordMismatch": "Passwords do not match.",
    "avatar_title": "Profile Picture",
    "account_data": "Account Information",
    "birthday": "Date of Birth",
    "new_password": "New Password",
    "confirm_password": "Confirm Password",
    "save": "Save All"
  },
  "primezord": {
    "title": "Primezord",
    "deposit": "Deposit",
    "withdraw": "Withdraw",
    "invest": "Investment",
    "modal_deposit": "Make a Deposit",
    "modal_withdraw": "Request Withdrawal",
    "modal_invest": "New Investment",
    "modal_subtitle": "Select the desired amount.",
    "modal_value": "Amount",
    "modal_confirm": "Confirm",
    "modal_cancel": "Cancel",
    "balance_label": "Zord Balance",
    "withdraw_balance_label": "Available for Withdrawal",
    "taxa": "Dollar Rate",
    "table_date": "Date",
    "table_value": "Amount",
    "table_status": "Status",
    "loading": "Loading investments...",
    "blocked_balance_label": "Blocked",
    "alert_value": "Select an amount"
  },
  "support": {
    "title": "Contact Support",
    "description": "Whether it's to ask questions, solve a problem or just chat with our team, we're here to help. Choose your preferred channel below and talk to us! Our support is real people, with fast and human service. 😉"
  },
  "earnings": {
    "title": "Earnings",
    "start_date": "Start Date",
    "end_date": "End Date",
    "date": "Date",
    "amount": "Amount",
    "action": "Action",
    "download": "Download PDF",
    "loading": "Loading earnings..."
  },
  "modal": {
    "newQuota": "New Quota",
    "confirmation": "Confirmation",
    "payment": "Payment",
    "choosePlan": "Choose the plan",
    "quotaValue": "Quota Value:",
    "continue": "Continue",
    "confirmPurchase": "Are you sure you want to purchase the {plan} quota for ${amount}?",
    "acceptTerms": "I have read and accept the",
    "termsOfUse": "terms of use",
    "confirm": "Confirm",
    "paymentValue": "Payment $ {amount}.",
    "paymentInstruction": "Complete the payment using the QR Code or copy the PIX line below.",
    "pixLine": "PIX line",
    "loadingPayment": "Loading",
    "alert_message": "⚠️ Payment confirmation may take up to 1 hour. Don’t worry, we’ll let you know once it’s all set!",
    "copy": "Copy",
    "back": "Back",
    "finish": "Finish"
  }
}
